module.exports = __webpack_public_path__ + "img/bullet_08_custom_heroes.c01dfbf4.png";